import { useEffect, useState } from "react";
import { gameApi } from "@/lib/api";
import { toast } from "sonner";
import { CalendarClock, Loader2, Save } from "lucide-react";

export const GameTimeAdmin = () => {
  const [t, setT] = useState(null);
  const [form, setForm] = useState({ player_number: "", tag: "", age: "" });
  const [busy, setBusy] = useState(false);
  const load = () => gameApi.get("/game/admin/game-time").then((r) => setT(r.data)).catch(() => setT(null));
  useEffect(() => { load(); }, []);

  const setAge = async () => {
    if (!form.player_number || form.age === "") { toast.error("Player number and age are required."); return; }
    setBusy(true);
    try {
      const { data } = await gameApi.post("/game/admin/horse-age", {
        player_number: Number(form.player_number), age: Number(form.age),
        tag: form.tag ? String(form.tag) : null,
      });
      toast.success(`${data.name} is now ${data.age} yr`);
      setForm({ player_number: "", tag: "", age: "" });
    } catch (e) { toast.error(e.response?.data?.detail || "Could not set age."); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-4" data-testid="admin-time">
      <div className="rounded-2xl border border-border bg-card p-4">
        <div className="mb-2 flex items-center gap-2">
          <CalendarClock className="text-secondary" size={18} />
          <h3 className="font-display text-lg font-bold text-primary">Game Time</h3>
        </div>
        {!t ? (
          <p className="flex items-center gap-2 py-4 text-sm text-muted-foreground"><Loader2 className="animate-spin" size={15} /> Loading…</p>
        ) : (
          <div className="space-y-1.5">
            <p className="text-sm text-muted-foreground">Current Game Year</p>
            <p className="font-display text-4xl font-bold text-primary" data-testid="admin-game-year">Game Year {t.game_year}</p>
            <p className="mt-2 text-sm text-muted-foreground">Next Game Year</p>
            <p className="text-sm font-bold text-secondary" data-testid="admin-next-rollover">{t.next_rollover_label}</p>
            <p className="mt-2 text-[11px] text-muted-foreground">1 real week = 1 in-game year. Advances automatically every Sunday at 12:00 AM Eastern Time; every horse ages +1 year.</p>
          </div>
        )}
      </div>

      <div className="rounded-2xl border border-border bg-card p-4">
        <h3 className="mb-1 font-display text-base font-bold text-primary">Edit a horse's age</h3>
        <p className="mb-3 text-[11px] text-muted-foreground">For troubleshooting only. This does NOT advance the Game Year. Leave Tag blank to target the player's active makeover horse.</p>
        <div className="grid grid-cols-3 gap-2">
          <input data-testid="age-player-number" value={form.player_number} onChange={(e) => setForm({ ...form, player_number: e.target.value.replace(/[^0-9]/g, "") })} placeholder="Player #" className="rounded-lg border border-border bg-background px-2 py-1.5 text-xs" />
          <input data-testid="age-tag" value={form.tag} onChange={(e) => setForm({ ...form, tag: e.target.value.replace(/[^0-9]/g, "") })} placeholder="Horse Tag # (optional)" className="rounded-lg border border-border bg-background px-2 py-1.5 text-xs" />
          <input data-testid="age-value" value={form.age} onChange={(e) => setForm({ ...form, age: e.target.value.replace(/[^0-9]/g, "") })} placeholder="Age (yr)" className="rounded-lg border border-border bg-background px-2 py-1.5 text-xs" />
        </div>
        <button data-testid="age-save" disabled={busy} onClick={setAge} className="mt-3 flex h-9 w-full items-center justify-center gap-1.5 rounded-lg bg-primary text-xs font-bold text-primary-foreground disabled:opacity-50">
          {busy ? <Loader2 className="animate-spin" size={14} /> : <Save size={14} />} Set Age
        </button>
      </div>
    </div>
  );
};
